'use client';

import { Spinner } from '@eliadmin/core/src/components/ui/spinner';

/**
 * „Vyhľadať“ inside the IČO field (Figma 60260:30060): text/brand Button M at the right edge of the
 * field, a spinner while the register lookup runs.
 */
export function LookupButton({
  label,
  loading,
  onClick,
}: {
  label: string;
  loading: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      aria-busy={loading}
      className="dlz-button-m flex min-w-[66px] justify-end rounded-sm text-[#D7191F] transition-colors hover:text-[#B5141A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012] disabled:cursor-wait"
    >
      {loading ? (
        <>
          <Spinner size="lg" />
          <span className="sr-only">{label}</span>
        </>
      ) : (
        label
      )}
    </button>
  );
}
